import { ChevronIcon, Text } from "@carbon6/c6-frontend-design";
import { useState, type ReactNode } from "react";
import { hatcheryTextModes } from "@/app/theme";
import styles from "./CollapsibleSection.module.css";

type CollapsibleSectionProps = {
  // 문자열이면 기본 타이포(caption-bold)로 감싼다. 노드면 호출부 구성을 그대로 쓴다.
  title: ReactNode;
  // 펼친 상태의 헤더 제목(선택)이다. "보기/닫기"처럼 상태에 따라 동사가 바뀔 때 쓴다. 없으면 title 을 쓴다.
  openTitle?: ReactNode;
  // 헤더 우측에 항상 보이는 현재 값 요약이다. 접혀 있어도 선택 상태를 읽을 수 있게 한다.
  summary?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
};

// c6에 접기 primitive가 없다. 그래서 이 컴포넌트가 페이지 전용 헤더 토글과 본문 구성을 소유한다.
export function CollapsibleSection({
  title,
  openTitle,
  summary,
  defaultOpen = false,
  children,
}: CollapsibleSectionProps): ReactNode {
  const [open, setOpen] = useState(defaultOpen);
  const titleNode = open ? (openTitle ?? title) : title;
  return (
    <section className={styles.section}>
      <button
        type="button"
        className={styles.header}
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {typeof titleNode === "string" ? (
          <Text variant={hatcheryTextModes["caption-bold"]} className={styles.title}>
            {titleNode}
          </Text>
        ) : (
          <span className={styles.title}>{titleNode}</span>
        )}
        {summary ? <span className={styles.summary}>{summary}</span> : null}
        <span className={styles.caretButton} data-open={open ? "true" : "false"} aria-hidden="true">
          <ChevronIcon className={styles.caretIcon} />
        </span>
      </button>
      {open ? <div className={styles.body}>{children}</div> : null}
    </section>
  );
}
